import Section, { Reveal, SectionHeading } from './Section'
import BlueprintGrid from './BlueprintGrid'
import CadableFlow from './CadableFlow'
import CadableButton from './CadableButton'
import { CADABLE_URL } from './ui'

const STEPS = [
  { title: 'Photograph and describe', body: 'A few photos of the real object and a sentence about what it is for.' },
  { title: 'Measure what it asks', body: 'CADable plans the measurements it needs and asks only for those.' },
  { title: 'Download, print or machine', body: 'A parametric CadQuery model, checked in a loop, exported as STEP, STL or FDM G-code.' },
]

/** CADable, the second product: steps on one side, the flow drawing on the other. */
export default function CadableSection() {
  return (
    <Section id="cadable" labelledBy="cadable-title" className="px-5 py-20 md:px-12 md:py-28">
      <SectionHeading id="cadable-title" label="Also from GCodr · CADable" lead="No drawing?" rest="Start from a photo." />
      <div className="mt-14 grid gap-10 lg:grid-cols-[1fr_1.15fr] lg:items-center">
        <Reveal>
          <ol className="space-y-7">
            {STEPS.map((s, i) => (
              <li key={s.title} className="flex gap-5">
                <span className="mt-0.5 font-mono text-[11px] tabular-nums text-cyan-400/80">{String(i + 1).padStart(2, '0')}</span>
                <div>
                  <h3 className="font-display text-lg font-semibold text-slate-100">{s.title}</h3>
                  <p className="mt-1 font-display text-[15px] leading-relaxed text-slate-400">{s.body}</p>
                </div>
              </li>
            ))}
          </ol>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <CadableButton />
            {!CADABLE_URL && <span className="font-mono text-[11px] text-slate-500">Opening to preview users soon.</span>}
          </div>
        </Reveal>
        <Reveal delay={0.08} className="relative overflow-hidden rounded-xl border border-white/10 bg-[#060b16]">
          <BlueprintGrid />
          <div className="relative flex items-center justify-between border-b border-white/[0.07] px-5 py-3 font-mono text-[10px] uppercase tracking-widest text-slate-500">
            <span>CADable · Photo to part</span>
            <span className="text-cyan-400/80">STEP · STL · G-code</span>
          </div>
          <div className="relative p-6 md:p-10">
            <CadableFlow />
          </div>
        </Reveal>
      </div>
    </Section>
  )
}
